import { observer } from 'mobx-react-lite';
import { cn } from '@/utils/utils';
import { useStore } from '@/hooks/useStore';
import SidebarToggle from './_components/SidebarToggle';
import { Button } from '@/components/common/Button';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/configs/constants';
import Menu from './_components/Menu';
import FullLogo from '@/assets/images/logo.svg';
import VerticalLogo from '@/assets/images/verticalLogo.svg';

export default observer(function Sidebar() {
    // hooks

    // store
    const {
        uiStore: { isOpenSidebar }
    } = useStore();

    return (
        <aside
            className={cn(
                'fixed top-0 left-0 z-20 h-screen -translate-x-full lg:translate-x-0 transition-[width] ease-in-out duration-300 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
                isOpenSidebar === false ? 'w-[90px]' : 'w-[19rem]'
            )}
        >
            <SidebarToggle />

            <div className='relative h-full flex flex-col px-3 py-4 shadow-md'>
                {/* Brand top */}
                <Button
                    className={cn(
                        'transition-transform ease-in-out duration-300 mb-1 h-9',
                        isOpenSidebar === false ?
                            'translate-x-1' :
                            'translate-x-0'
                    )}
                    variant='link'
                    asChild
                >
                    <Link
                        to={ROUTES.dashboard.href}
                        className='flex items-center justify-center'
                    >
                        <img src={isOpenSidebar ? FullLogo : VerticalLogo} className='h-11' alt='logo' />
                    </Link>
                </Button>

                {/* Menu */}
                <Menu isOpen={isOpenSidebar} />
            </div>
        </aside>
    );
});
